import Vue from 'vue'

const namespaced = true

/* checkedObject: {
**   'id': {
**     file: {}
**   }
** }
*/
const state = {
  checkedObject: {}
}

const getters = {
  checkedObject: state => state.checkedObject,
  checkedFiles: state => {
    return Object.keys(state.checkedObject)
      .map(key => state.checkedObject[key])
      .filter(f => f !== undefined)
  },
  checkedById: state => id => state.checkedObject[id]
}

const actions = {
  setChecked ({ state, commit }, { id, file, value }) {
    const obj = state.checkedObject[id]
    if (!!obj ^ value) {
      commit('setChecked', { id, file, value })
    }
  },
  clearChecked ({ commit }) {
    commit('clearChecked')
  }
}

const mutations = {
  setChecked (state, { id, file, value }) {
    if (value) Vue.set(state.checkedObject, id, file)
    else Vue.set(state.checkedObject, id, undefined)
  },
  clearChecked (state) {
    state.checkedObject = {}
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
